import { ReactNode } from 'react';
import styled, { useTheme } from 'styled-components';
import { LXbody } from '../../texts/lxText';
import { VerticalDivider } from '../divider/lxDivider';
import Column from './column';
import Row from './row';
import SizedBox from './sizedBox';

interface LXInformationCardProps {
  left: Map<string, string>;
  rightTop?: ReactNode;
  right: Map<string, string>;
}

const Padding = styled.div`
  padding: 16px 0px 0px 0px;
`;

const LXInformationCard: React.FC<LXInformationCardProps> = (props) => {
  const theme = useTheme();

  const buildItem = (key: any, label: string, value: string) => {
    return (
      <Row key={key}>
        <LXbody
          color={theme.colors.caption}
          width={'120px'}
          flexShrink={0}
          flexBasis={'130px'}
        >
          {label}
        </LXbody>
        <SizedBox width={20}></SizedBox>
        <LXbody
          flexGrow={1}
          flexShrink={1}
          flexBasis={'auto'}
          whiteSpace={'pre-line'}
          height={'auto'}
          overflowWrap={'break-word'}
        >
          {value}
        </LXbody>
      </Row>
    );
  };

  const buildInfos = (infos: Map<string, string>) => {
    const keys = Array.from(infos.keys());
    const values = Array.from(infos.values());

    return keys.map((label, idx) => {
      const value = values[idx];
      if (idx === 0) {
        return buildItem(idx, label, value);
      } else {
        return <Padding key={idx}>{buildItem(idx, label, value)}</Padding>;
      }
    });
  };

  return (
    <Row>
      <Column flexGrow={1} flexBasis={'50%'} flexShrink={1}>
        {buildInfos(props.left)}
      </Column>
      <VerticalDivider></VerticalDivider>
      <Column flexGrow={1} flexBasis={'50%'} flexShrink={1}>
        {props.rightTop}
        {props.rightTop && <SizedBox height={16}></SizedBox>}
        {buildInfos(props.right)}
      </Column>
    </Row>
  );
};

export default LXInformationCard;
